import { Component, ViewChild,OnDestroy,OnInit, inject, ViewChildren, QueryList, ElementRef, ChangeDetectorRef, HostListener } from '@angular/core';
import { CdkDragDrop, CdkDropList, CdkDrag, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatTable, MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { AccountSalaryRefService } from './account-salary-ref.service';
import { NgbModal, NgbModalRef, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import { UserService } from '@services/core/user.service';
import { Entity } from '@model/entity.model';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { FilterModel } from './account-salary-ref.model';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core'; // E
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { BudgetFactorRefService } from '../budget-factor-ref/budget-factor-ref.service';
import { BudgetGenerateService } from '@services/budget-generate.service';


@Component({
  selector: 'app-account-salary-ref',
  templateUrl: 'account-salary-ref.component.html',
  styleUrl: 'account-salary-ref.component.css',
  standalone: true,
  imports: [CdkDropList,
    CdkDrag,
    MatTableModule,
    MatIconModule,
    MatRippleModule,
    MatCheckboxModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule, 
    CommonModule,
    MonacoEditorModule
  ],
  providers: [NgbModal],
})
export class AccountSalaryRefComponent  implements OnInit,OnDestroy{
  @ViewChild('table', { static: true }) table!: MatTable<any>;
  @ViewChildren('input') inputs!: QueryList<ElementRef>;
  @ViewChild('modal_account', { static: true }) modalAccount: any;
  @ViewChild('modal_formula_editing', { static: true }) modalFormulaEditing: any;
  @ViewChild('nameInput') nameInput: ElementRef;
  @ViewChild('ngSelect', { static: false }) ngSelectAssinet: NgSelectComponent;
  @ViewChild('editorContainer', { static: true }) editorContainer!: ElementRef;
  private modalRef: NgbModalRef;
  public filter: FilterModel = new FilterModel();
  public accountSalaryRefService = inject(AccountSalaryRefService);
  public budgetFactorRefService = inject(BudgetFactorRefService);
  private _identityService = inject(UserService);
  private entitySelected: Entity;
  public itemsTravel:{ [key: string]: any[] } = {};
  public formulaEditing=false;
  private timeout: any;
  public dataSource;
  public employeeType;
  public employeeTypeSelected;
  public formAccountSalaryRef: FormGroup;
  public formulaRefTemp;
  public formulaRef;
  public budgetFactorRef;
  id;
  editorOptions = {
    theme: 'vs-light',
    language: 'formulaLang',
    automaticLayout: true,
    minimap: { enabled: false },
    hover: {
      enabled: true,
      above: false 
    }
  };
 budgetGenerateService = inject(BudgetGenerateService); 
 variablesMap;
 variablesMapTemp;
 monacoInitialized = false;
 private hoverDisposable: any;
 private completionDisposable: any;
  public account;
  public accountTemp;

  displayedColumns: string[] = [
    'order',
    'accountCode',
    'accountName',
    'hint',    
    'block',
    'setting'];
  constructor(private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
  ) {

  

  }


  /**crear formulario reactivo diverso*/
  createFormAccount() {
    this.formAccountSalaryRef = this.formBuilder.group({
      accountCode: [undefined, [Validators.minLength(3)]],
      hint: [''],
      employeeType: ['', [Validators.required]],
    });
  }


 /**Activa el input y le da el foco */
 enableEditing(element, field) {
  element['isEditing' + field] = true;
  this.cdr.detectChanges();
  setTimeout(() => {
    const input = this.inputs.toArray()[0];
    if (input && input.nativeElement) {
      input.nativeElement.focus();
    }
  }, 0);
}


  /**Ajusta el alto de scroll y la posicion de del input en relacion a la posicion del contenedor */
  autoGrow(event: Event): void {
    clearTimeout(this.timeout);
    const textArea = event.target as HTMLTextAreaElement;
    const parent = textArea.parentElement;
    const topParent = parent.getBoundingClientRect()
    const newTop = topParent.top - 16;
    textArea.style.height = textArea.scrollHeight + 2 + 'px';
    textArea.style.top = newTop + 'px';
    textArea.style.left = topParent.left + 'px';
  }

  /**Ajusta el alto y la posicion de del input a la posicion del contenedor */
  autoTop(event: Event): void {
    clearTimeout(this.timeout);
    const textArea = event.target as HTMLTextAreaElement;
    const parent = textArea.parentElement;
    const topParent = parent.getBoundingClientRect()
    const newTop = topParent.top - 16;
    textArea.style.height = 55 + 'px';
    textArea.style.top = newTop + 'px';
  }


  /**mueve la fila y ejecuta el metodo para actualizar el nuevo orden */
  drop(event: CdkDragDrop<string>) {
    const previousIndex = this.dataSource.findIndex(d => d === event.item.data);
    moveItemInArray(this.dataSource, previousIndex, event.currentIndex);
    this.updateOrder(this.dataSource)
    this.table?.renderRows();
    this.notification('Datos Actualizados');
  }

 
  /**Metodo para actualizar el orden del plan de cuenta */
  updateOrder(data) {
    const bulkUpdates = data.map((account, index) => {
      return { id: account.id, order: index + 1 };
    })
    this.accountSalaryRefService.updateAccountSalaryRefBulk(bulkUpdates).subscribe(res => {
      this.getAccountSalaryRef()
    })
  }
/**trae las cuentas */
getAccount() {
  delete this.filter.typeId;
  this.budgetGenerateService.getAasinetAccount({code:'411'}).subscribe(res => {
    this.accountTemp = JSON.parse(JSON.stringify(res));
    this.account = this.mapSelect(res)
  })
}



  setAccount(id: string) {
    return this.dataSource.find(acc => acc.id == id);
  }


  /**Actualiza el items travel*/
  updateItemsAccount(data, field, newValue) {
    clearTimeout(this.timeout);
    let account = this.setAccount(data.id)
    if (account[field] != newValue) {
      account[field] = newValue
      this.accountSalaryRefService.updateAccountSalaryRef({ id: data.id, [field]: newValue }).subscribe(res => {
        account.isEditingCal = false;
        this.notification('Datos Actualizados');
      })
    }
  }


   


  /**Elimina un items de travel*/
  deleteItemsAccount(params) {
    Swal.fire({
      icon: 'warning',
      title: 'Alerta ',
      text: '¿Desea eliminar el item de calculo ' + params.accountCode + ' ' + params.accountName + '?',
      toast: false,
      position: 'center',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      timer: null,
      timerProgressBar: false
    }).then((result) => {
      if (result.isConfirmed) {
       this.accountSalaryRefService.deleteAccountSalaryRef({ id: params.id }).subscribe(res => {
          this.notification('Item de calculo ' + params.accountCode + ' ' + params.accountName + 'eliminada ');
          this.getAccountSalaryRef();
      })

      }
    })



  }


  hover(monaco) {
    this.hoverDisposable=monaco.languages.registerHoverProvider('formulaLang', {
      provideHover: (model, position) => {
        const lineContent = model.getLineContent(position.lineNumber);
        const regex = /\{([a-zA-Z0-9_]+)\}/g;
        let match;
        let hover=null;

        while ((match = regex.exec(lineContent)) !== null) {
          const [full, key] = match;
          const start = match.index + 1;
          const end = start + key.length;

          if (position.column >= start && position.column <= end + 1) {
            const desc = this.variablesMap[key];
            if (desc) {
              hover = {
                range: new monaco.Range(
                  position.lineNumber,
                  start,
                  position.lineNumber,
                  end + 1
                ),
                contents: [{ value: `**${desc}**` }]
              };
            }
          }
        }

        return hover;
      }
    });
  }


  autoComplete(monaco) {
    this.completionDisposable=monaco.languages.registerCompletionItemProvider('formulaLang', {
      triggerCharacters: ['{'],
      provideCompletionItems: () => {
        const suggestions = Object.keys(this.variablesMap).map(key => ({
          label: `{${key}}`,
          kind: monaco.languages.CompletionItemKind.Variable,
          insertText: `${key}}`,
          detail: this.variablesMap[key]|| 'Descripción no disponible'
        }));
        return { suggestions };
      }
    });

  }

  
  
 onMonacoInit() {
  
  const monaco = (window as any).monaco;
  if (!monaco) return;

  if (!this.monacoInitialized) {
    monaco.languages.register({ id: 'formulaLang' });
    
    monaco.languages.setMonarchTokensProvider('formulaLang', {
      tokenizer: {
        root: [
          [/\{[a-zA-Z0-9_]+\}/, 'variable'],
          [/if|;/, 'keyword'],
          [/[0-9]+/, 'number'],
          [/[\+\-\*\/\(\)]/, 'operator']
        ]
      }
    });

    this.hover(monaco);
    this.autoComplete(monaco);   
    this.monacoInitialized = true; // marca que ya inicializamos
  }
}

formatFormula(code: string): string {
  if (!code) return '';
  return code
    .replace(/;/g, ';\n')
    .replace(/\(/g, '(\n  ')
    .replace(/\)/g, '\n)')
    .replace(/\+/g, ' + ')
    .replace(/\*/g, ' * ')
    .replace(/\//g, ' / ');
}





  ngOnInit() {
    this.getEmployeeType();
    this.createFormAccount();
    this.getBudgetFactorRef();
    this.getAccount()
    
  }


  getBudgetFactorRef() {
    this.budgetFactorRefService.getBudgetFactorRef().subscribe(res => {
      this.budgetFactorRef = res;
      this.variablesMap = this.budgetFactorRef.reduce((acc, item) => {
        acc[item.code] = item.name;
        return acc;
      }, {});
      this.variablesMap[1] = 'Puntaje Empleado';
      this.variablesMap[2] = 'Carga Infantil';
      this.variablesMapTemp = JSON.parse(JSON.stringify(this.variablesMap));

    })
  }
  


  getEmployeeType() {
    this.accountSalaryRefService.getEmployeeType().subscribe(res => {
      this.employeeType = res;    
      this.employeeTypeSelected = this.employeeType[0].id;  
      this.getAccountSalaryRef(); 

    })
  }

 
  tabChange(employeeType) {
    this.employeeTypeSelected=employeeType.id;
    this.changeEmployeeType();
  }


  /**trae el plan de cuentas */
  getAccountSalaryRef() {
    this.accountSalaryRefService.getAccountSalaryRef().subscribe(res => {
      this.formulaRef = res;
      this.formulaRefTemp = JSON.parse(JSON.stringify(this.formulaRef));
      this.changeEmployeeType();

    })
  }



  /*abre los modales */
  open(content, size?) {
    this.modalRef = this.modalService.open(content, size);
  }

  /*cierra los modales */
  close() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  /**abre el modal de agregar cuenta */
  openModalAccount() {
    this.changeEmployeeType()
    this.open(this.modalAccount,'lg')
  }

  openModalFormulaEditing(params) {
    this.formAccountSalaryRef.patchValue(params)   
    this.formAccountSalaryRef.get('calculation').setValue(
      this.formatFormula(params.calculation)
    );
     
    this.id = params.id;
    this.formulaEditing=true;
    
  }

  changeEmployeeType() {
    this.dataSource = this.formulaRefTemp.filter((a) => a.employeeType == this.employeeTypeSelected);
    this.account = this.mapSelect(this.accountTemp);
    let hover = this.dataSource.reduce((acc, item) => {
      acc[item.code] = item.name;
      return acc;
    }, {});
    this.variablesMap = { ...hover, ...this.variablesMapTemp };
    this.formAccountSalaryRef.get('employeeType').patchValue(this.employeeTypeSelected);
  }

  /**busca los las cuentas q no existen  */
  findAcountPlan(code): boolean {
    let r = false;
    try {
      r = !this.itemsTravel[this.employeeType].some((a) => a.accountCode == code);
    }
    catch {
    }
    return r
  }


  /**busca los las cuentas q existen  */
  findAcount(code): boolean {
    let data = this.formulaRefTemp?.filter((a) => a.employeeType == this.employeeTypeSelected)
    return !data?.some((a) => a.accountCode == code);
  }



  /*mapea los datos del ng-select deshabilita los registros q ya entan registrado el diverso de empleado */
  mapSelect(data) {
    data=data.filter(d=>d.acceptEntries)
    let newData = data.map((d) => {
      const name = d.name;
      const isActive = this.findAcount(d.code)
      return {
        code: d.code,
        nameCode: d.code + ' - ' + name,
        name: name,
        disabled: !isActive,
        isActive: isActive
      }
    });
    return newData
  }


  resetForm() {
    this.formAccountSalaryRef.patchValue({
      accountCode: undefined,
      hint: '',
      calculation: ''
    });
    this.formAccountSalaryRef.get('accountCode')?.markAsPristine();
    this.formAccountSalaryRef.get('hint')?.markAsPristine();


  }




  /**al cerrar el ngselect le pasa el foco y el valor al input de displayName */
  submitNewItems() {
     if (this.formAccountSalaryRef.valid) {
      this.formAccountSalaryRef.value.employeeType=this.employeeTypeSelected;
      this.accountSalaryRefService.saveAccountSalaryRef(this.formAccountSalaryRef.value).subscribe(res => {
        this.getAccountSalaryRef();       
        this.resetForm();
        this.close();
        this.notification('Item guardado exitosamente');
      })
    }
  }


    /**al cerrar el ngselect le pasa el foco y el valor al input de displayName */
    submitEditItems() {
      if (this.formAccountSalaryRef.valid) {
        let data = this.formAccountSalaryRef.value;
        data.id = this.id;
        data.calculation = data.calculation
        .replace(/\s+/g, ' ') 
        .replace(/\n/g, '')   
        .replace(/\r/g, '')    
        .trim();             
      
       this.accountSalaryRefService.updateAccountSalaryRef(data).subscribe(res => {
            this.formulaEditing=false;
            this.getAccountSalaryRef();       
            this.resetForm();
            this.notification('Item guardado exitosamente');
       })
     }
   }


  notification(title) {
    const Toast = Swal.mixin({
      icon: 'success',
      title: title,
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 2500,
      timerProgressBar: true,
    });
    Toast.fire();
  }

  ngOnDestroy() {
    // 👇 Limpia para que no quede duplicado
    if (this.hoverDisposable) {
      this.hoverDisposable.dispose();
      this.hoverDisposable = null;
    }
    if (this.completionDisposable) {
      this.completionDisposable.dispose();
      this.completionDisposable = null;
    }
  }

}


